import { render, staticRenderFns } from "./editMediationPage.vue?vue&type=template&id=36545453&scoped=true&"
import script from "./editMediationPage.vue?vue&type=script&lang=js&"
export * from "./editMediationPage.vue?vue&type=script&lang=js&"
import style0 from "./editMediationPage.vue?vue&type=style&index=0&id=36545453&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36545453",
  null
  
)

export default component.exports